import { render, staticRenderFns } from "./TeamFilter.vue?vue&type=template&id=23fa23e9"
import script from "./TeamFilter.vue?vue&type=script&lang=js"
export * from "./TeamFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports